// Material Kit 2 React pages
import Home from "pages/Home";

export default function HomePage() {
  return <Home />;
}
